var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "contact-inputs" },
    [
      _c("h2", { staticClass: "mb-5" }, [
        _vm._v(_vm._s(_vm.$l10n.__("Informations de contact")))
      ]),
      _vm._v(" "),
      _c(
        "div",
        { staticClass: "flex-row" },
        [
          _c(
            "el-form-item",
            {
              staticClass: "wp-5",
              attrs: { prop: "name", label: _vm.$t.__("common.labels.name") }
            },
            [
              _c("el-input", {
                on: {
                  input: function($event) {
                    return _vm.$emit("input", _vm.value)
                  }
                },
                model: {
                  value: _vm.value.name,
                  callback: function($$v) {
                    _vm.$set(_vm.value, "name", $$v)
                  },
                  expression: "value.name"
                }
              })
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "el-form-item",
            {
              staticClass: "wp-5 ml-4",
              attrs: {
                prop: "forename",
                label: _vm.$t.__("common.labels.first_name")
              }
            },
            [
              _c("el-input", {
                on: {
                  input: function($event) {
                    return _vm.$emit("input", _vm.value)
                  }
                },
                model: {
                  value: _vm.value.forename,
                  callback: function($$v) {
                    _vm.$set(_vm.value, "forename", $$v)
                  },
                  expression: "value.forename"
                }
              })
            ],
            1
          )
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "el-form-item",
        {
          attrs: {
            prop: "phone",
            label: _vm.$t.__("common.labels.phone"),
            error: _vm.errors.get("contactPhone")
          }
        },
        [
          _c("tel-input", {
            staticClass: "wp-10 contact-input-tel",
            attrs: { mode: "edit" },
            on: {
              change: function($event) {
                return _vm.$emit("input", _vm.value)
              }
            },
            model: {
              value: _vm.value.phone,
              callback: function($$v) {
                _vm.$set(_vm.value, "phone", $$v)
              },
              expression: "value.phone"
            }
          })
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "el-form-item",
        {
          attrs: {
            prop: "email",
            label: _vm.$t.__("common.labels.email_address")
          }
        },
        [
          _c("el-input", {
            on: {
              input: function($event) {
                return _vm.$emit("input", _vm.value)
              }
            },
            model: {
              value: _vm.value.email,
              callback: function($$v) {
                _vm.$set(_vm.value, "email", $$v)
              },
              expression: "value.email"
            }
          })
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }